export const AUTH_AUTO_SIGNIN = 'auth/AUTH_AUTO_SIGNIN';
export const CANCEL_AUTO_SIGNIN = 'auth/CANCEL_AUTO_SIGNIN';

export const AUTH_SIGNOUT_REQUEST = 'auth/AUTH_SIGNOUT_REQUEST';
